import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar } from "@mui/material";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { convertToLetters } from "utils/convertToLetters";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import useGetPDFViewer from "hooks/useGetPDFViewer";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import {
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";

const CommentCard: FC<Props> = ({
  annotation,
  handleEditMode,
  handleDeleteAnnotation,
  showCopyToWord,
}) => {
  const { t } = useTranslation();
  const contentRef = useRef();
  const [showMore, setShowMore] = useState(false);
  const [showLink, setShowLink] = useState(false);

  const [dropdown, setDropdown] = useState(false);
  const ref = useRef<HTMLDivElement>();
  const outsideRef = useRef<HTMLDivElement>();
  const { annotation: annotationId } = useGetPDFViewer();

  useOnClickOutside(outsideRef, () => {
    setDropdown(false);
  });

  useLayoutEffect(() => {
    if (contentRef && contentRef.current) {
      if (contentRef.current.clientHeight < contentRef.current.scrollHeight) {
        setShowLink(true);
      }
    }
  }, [contentRef]);

  useEffect(() => {
    if (!ref?.current) return;
    if (annotationId() === annotation.Id) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  }, [annotationId(), ref]);

  const onClickMore = () => {
    setShowMore(!showMore);
  };

  const handleWordTransfer = () => {
    navigator.clipboard.writeText(
      `### NOTA ### ${annotation.Comments.at(0).Text}`
    );
  };

  return (
    <div
      ref={ref}
      className={`${styles.card} ${
        annotation.Id === annotationId() && styles.active
      }`}
    >
      <div className={styles.avatar}>
        <Avatar className={styles.av}>
          {convertToLetters(annotation.Author)}
        </Avatar>
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.name}>{annotation.Author}</div>
          <div ref={outsideRef} className={styles.options}>
            <div className={styles.date}>
              {moment(annotation.CreationDate).format("DD.MM.YY")}
            </div>
            <FontAwesomeIcon
              onClick={() => setDropdown(!dropdown)}
              className={styles.optionIcons}
              icon={faEllipsisV}
            />

            {dropdown && (
              <div className={styles.dropdown}>
                <div className={styles.dropdownWrapper}>
                  <div
                    onClick={() => {
                      setDropdown(false);
                      handleEditMode(annotation);
                    }}
                    className={styles.dropdownBox}
                  >
                    {t("common.edit")}
                  </div>
                  <div
                    className={styles.dropdownBox}
                    onClick={() => {
                      setDropdown(false);
                      handleDeleteAnnotation(annotation);
                    }}
                  >
                    {t("common.delete")}
                  </div>
                  {showCopyToWord && (
                    <div
                      className={styles.dropdownBox}
                      onClick={() => {
                        setDropdown(false);
                        handleWordTransfer(annotation);
                      }}
                    >
                      {t("documents.insertToWord")}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {annotation?.Comments?.[0] && (
          <div>
            <div
              ref={contentRef}
              dangerouslySetInnerHTML={{
                __html: annotation.Comments.at(0).Text,
              }}
              className={classNames(styles.msg, showMore ? styles.grow : "")}
            ></div>
            <div className={styles.tools}>
              {showLink && (
                <div className={styles.expandButton} onClick={onClickMore}>
                  {showMore ? t("common.collapse") : t("common.expand")}
                  <FontAwesomeIcon icon={showMore ? faAngleUp : faAngleDown} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentCard;
